/**
 * promo-offer-copy.js
 * Lightweight, dependency-free click handler for the "Offers" product-page
 * block (blocks/promo-offers.liquid + blocks/_promo-offer-item.liquid).
 * Copies a discount code to the clipboard when its pill is clicked and
 * shows brief "Copied!" feedback. No framework/component base required.
 */
(function () {
  if (window.__promoOfferCopyInit) return;
  window.__promoOfferCopyInit = true;

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      /* no-op: clipboard unavailable */
    }
    document.body.removeChild(textarea);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        fallbackCopy(text);
      });
    }
    fallbackCopy(text);
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-promo-copy]');
    if (!button) return;

    var code = button.getAttribute('data-promo-copy');
    if (!code) return;

    copyText(code).then(function () {
      var label = button.querySelector('[data-promo-copy-text]');
      var originalText = button.getAttribute('data-original-text') || (label ? label.textContent : '');

      if (!button.getAttribute('data-original-text') && label) {
        button.setAttribute('data-original-text', originalText);
      }

      button.setAttribute('data-copied', 'true');
      if (label) label.textContent = 'Copied!';

      clearTimeout(button.__promoCopyTimeout);
      button.__promoCopyTimeout = setTimeout(function () {
        button.removeAttribute('data-copied');
        if (label) label.textContent = button.getAttribute('data-original-text');
      }, 1800);
    });
  });
})();
